import { classNames } from 'primereact/utils';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IAuftraggeber } from '../../../types/Types';
import LandingpageHeader from '../../header/LandingpageHeader';
import styles from '../admin.module.scss';
import { useGetAuftraggeberListeMutation } from '../../../api/OfficeAPI';

export default function AuftraggeberMain() {

  const [isLoaded, setLoaded] = useState<boolean>(false);
  const [liste, setListe] = useState<IAuftraggeber[]>([]);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [getAuftraggeberListeAPI] = useGetAuftraggeberListeMutation();

  const init = () => {
    getAuftraggeberListeAPI().unwrap()
      .then(data => setListe(data))
      .then(() => setLoaded(true))
      .catch((e) => console.log(e))
  }

  useEffect(() => {
    init();
  }, []);

  return (
    <>
      <div className={classNames(styles.centerContainer)}>

        <LandingpageHeader />

        <div className='container' >

          <button
            onClick={() => {
              navigate({
                pathname: "/",
                search: ""
              });
            }}

            style={{ marginBottom: "20px" }}
            className=' btn btn-outline-primary'
          >
            <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
          </button>


          <div className={styles['wg-detail-ueb']}>
            <div><span style={{ fontSize: "28pt", fontWeight: "700" }}>Auftraggeber</span></div>
            <div style={{ textAlign: "end" }}></div>
          </div>
          <button className="btn btn-primary" onClick={() => navigate('detail', { state: { view: 'create' } })}><i className="bi bi-plus"></i><span style={{ marginLeft: "1em" }}>NEU ANLEGEN</span></button>
          <div style={{ display: "grid", fontWeight: "bold", gridTemplateColumns: "2fr 1fr", gap: "10px", alignItems: "center", padding: "10px", marginTop: "10px", border: "1px solid #ccc" }}>
            <div>Name</div>
            <div style={{ textAlign: "end" }}>
              Option
            </div>
          </div>
          {
            (isLoaded && liste?.map((e, index) =>
              <div key={index} style={{ display: "grid", fontWeight: "bold", gridTemplateColumns: "2fr 1fr", gap: "10px", alignItems: "center", padding: "10px", marginTop: "10px", border: "1px solid #ccc" }}>
                <div>{e.name}</div>
                <div style={{ textAlign: "end" }}>
                  <button onClick={() => navigate('detail', { state: { view: 'detail', id: e.uid } })} className={styles["wg-a"]} ><i className="bi bi-pencil"></i></button>
                </div>
              </div>)
            )
          }
          {(!isLoaded && <>Lädt...</>)}
        </div>
      </div>

    </>
  );
}